/**
 * O que dizer a quem entrou com senha certa e não recebeu sessão.
 *
 * Login válido sem sessão tem dois motivos diferentes, e a mensagem precisa
 * separar os dois: a conta ainda não foi convidada para clínica nenhuma, ou todas
 * as clínicas dela estão fechadas. Suspensa (0090 tira o acesso; 0096 conta o
 * motivo) ou cancelada (desde a 0150, quando o teste cancelado chega ao fim). Dizer
 * "sem vínculo" a quem está suspenso manda abrir o chamado errado.
 */

export interface SituacaoDoVinculo {
    clinica: string;
    situacao: string;
}

export const SEM_VINCULO = 'Esta conta ainda não está vinculada a nenhuma clínica.';

const FECHADAS = new Set(['suspensa', 'cancelada']);

export function mensagemSemAcesso(vinculos: readonly SituacaoDoVinculo[]): string {
    const fechadas = vinculos.filter((v) => FECHADAS.has(v.situacao));
    if (vinculos.length === 0 || fechadas.length !== vinculos.length) return SEM_VINCULO;
    const [unica] = fechadas;
    if (fechadas.length === 1 && unica) {
        return unica.situacao === 'cancelada'
            ? `A clínica ${unica.clinica} foi cancelada. Para voltar a usar a Fórmula MED, fale com o suporte.`
            : `A clínica ${unica.clinica} está suspensa. Fale com o suporte da Fórmula MED para reativar o acesso.`;
    }
    const nomes = fechadas.map((v) => v.clinica).join(', ');
    return fechadas.every((v) => v.situacao === 'suspensa')
        ? `As clínicas ${nomes} estão suspensas. Fale com o suporte da Fórmula MED para reativar o acesso.`
        : `As clínicas ${nomes} estão suspensas ou canceladas. Fale com o suporte da Fórmula MED para reativar o acesso.`;
}
